<template>
  <div v-if="isLoading" class="order contents"></div>
  <div v-else id="contents" class="order contents pay">
    <template v-if="rendingUrl">
      <iframe
        ref="iframe"
        class="processing"
        :src="rendingUrl"
        @load="handleLoadForIframe"
      ></iframe>
    </template>
    <template v-else>
      <div
        :class="{
          orderDelivery: isShippingProduct,
          postEmpty: deliveryInformation.address === null,
          wide: deliveryInformation.address && postRequest === 0
        }"
      >
        <div v-if="isShippingProduct" class="deliveryInfo">
          <h2>배송정보</h2>
          <template v-if="deliveryInformation.address">
            <div class="postInfo">
              <ul>
                <li class="personalInfo">
                  <div>
                    <strong class="name">
                      {{ deliveryInformation.receiverName }}
                    </strong>
                    <span class="phone">
                      {{ deliveryInformation.phoneNumber }}
                    </span>
                  </div>
                  <button class="btn btnMore" @click="onClickChangeAddress">
                    배송지 변경
                    <i class="icon iconMore2"></i>
                  </button>
                </li>
                <li>
                  <span>{{ `[${deliveryInformation.zipCode}]` }}</span>
                  {{ deliveryInformation.address }}
                </li>
                <li>
                  <input
                    class="borderedText"
                    v-model="deliveryInformation.detailAddress"
                    type="text"
                  />
                </li>
              </ul>

              <div class="postExtraInfo">
                <custom-select-box
                  v-model="postRequest"
                  :items="postRequestsComment"
                  firstItem="직접입력"
                />
                <input
                  v-if="postRequest === 0"
                  class="postMessage"
                  type="text"
                  placeholder="배송시 요청사항 입력 (최대 50자)"
                  :value="postMessage"
                  @input="changePostMessage"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <p class="comment">
              배송 상품이 있습니다. 배송 받을 주소를 입력해주세요.
            </p>
            <button class="btn btn_address" @click="showLayer(true)">
              배송지 입력
            </button>
          </template>
        </div>

        <post-address
          v-if="postAddressLayer"
          @showLayer="showLayer"
          @changeDeliveryInformation="changeDeliveryInformation"
        ></post-address>
      </div>
      <div class="orderProduct">
        <h2>구매상품정보</h2>
        <ul class="listTypeCart">
          <li
            class="productItem"
            v-for="(product, index) in productList"
            :key="index"
          >
            <product-item
              :product="product"
              :isSaleAfter="true"
              :isCountVisible="true"
            />
          </li>
        </ul>
      </div>
      <div class="orderPrice">
        <h2>최종 결제금액</h2>
        <div>
          <dl>
            <dt>총 상품 금액</dt>
            <dd>
              {{ productPriceObj.displayPrice.addComma()
              }}{{ productPriceObj.currencyUnit }}
            </dd>
          </dl>
          <dl>
            <dt>할인금액</dt>
            <dd>
              -{{ productPriceObj.benefit.addComma()
              }}{{ productPriceObj.currencyUnit }}
            </dd>
          </dl>
          <dl>
            <dt>총 결제 금액</dt>
            <dd>
              {{ productPriceObj.price.addComma()
              }}{{ productPriceObj.currencyUnit }}
            </dd>
          </dl>
        </div>
      </div>
      <div v-if="!isGameCoinPayment" class="orderPayMethod">
        <h2>결제수단</h2>
        <!-- <button
          v-if="limitPricePage"
          class="btLimitGuide"
          @click="flagLimitGuide = true"
        >
          <i class="icon iconQuestion"></i>
          한도안내
        </button> -->
        <ul :class="`pay${isMobileOS}`">
          <li v-for="(payment, index) in paymentList" :key="index">
            <form-radio
              :id="`paySelect${payment.categoryCode}`"
              :class="`paySelect${payment.categoryCode}`"
              name="paySelect"
              :labelText="getPaymentName(payment.categoryCode)"
              :checked="paymentIndex === index"
              @handleCheck="handleCheck('radio', index)"
            ></form-radio>
          </li>
        </ul>
        <dl v-if="selectedPayment && selectedPayment.event">
          <dt>
            <i class="icon iconLoudspeaker"></i>
            이벤트
          </dt>
          <dd>{{ selectedPayment.eventName }}</dd>
        </dl>
      </div>
      <div class="orderAgree" v-if="selectedPayment">
        <h2>
          <form-checkbox
            id="allAgree"
            labelText="전체 동의하기"
            :checked="isAllAgree"
            @handleCheck="handleCheck('check', 'all')"
          ></form-checkbox>
        </h2>
        <ul>
          <li>
            <form-checkbox
              id="agree"
              labelText="구매조건 확인 및 결제진행 동의"
              :checked="agree"
              @handleCheck="handleCheck('check', 'agree')"
            ></form-checkbox>
          </li>
          <li v-if="isShippingProduct">
            <form-checkbox
              id="agree2"
              labelText="개인정보 수집 및 이용 동의"
              :checked="agree2"
              @handleCheck="handleCheck('check', 'agree2')"
            ></form-checkbox>
            <button
              type="button"
              class="btShare"
              @click="checkPrivacyShow = true"
            >
              <span>상세보기</span>
              <i class="icon iconMore4"></i>
            </button>
          </li>
          <template v-if="selectedPayment && agreementList">
            <li v-for="(el, index) in agreementList" :key="index">
              <form-checkbox
                :id="`agree${index}`"
                :labelText="el.title"
                :checked="agrees[index]"
                @handleCheck="handleCheck('check', index)"
              ></form-checkbox>
              <button
                type="button"
                class="btShare"
                @click="handleClickDetail(agreementList[index])"
              >
                <span>상세보기</span>
                <i class="icon iconMore4"></i>
              </button>
            </li>
          </template>
        </ul>
      </div>
      <ul class="orderAnnounce" v-if="selectedPayment">
        <li>- 구매 후 7일이내 구매확정 전 청약철회 가능합니다.</li>
        <li>
          - 유효기간 경과 시 쿠폰 사용이 불가하며 고객센터를 통해 문의
          부탁드립니다.
        </li>
      </ul>
      <div v-if="isGameCoinPayment" class="orderPayCoin">
        <h2>보유 포인트</h2>
        <div>
          <dl>
            <dt>{{ balance.currencyName }}</dt>
            <dd>
              <b>{{ balance.total.addComma() }}{{ balance.currencyUnit }}</b>
            </dd>
          </dl>
          <ul class="payCoinAgree">
            <li>
              <form-checkbox
                id="agreePayCoin"
                labelText="구매조건 확인 및 결제진행 동의"
                :checked="agreePayCoin"
                @handleCheck="handleCheck('check', 'agreePayCoin')"
              ></form-checkbox>
            </li>
            <li v-if="isShippingProduct">
              <form-checkbox
                id="agree2"
                labelText="개인정보 수집 및 이용 동의"
                :checked="agreePayCoin2"
                @handleCheck="handleCheck('check', 'agreePayCoin2')"
              ></form-checkbox>
              <button
                type="button"
                class="btShare"
                @click="checkPrivacyShow = true"
              >
                <span>상세보기</span>
                <i class="icon iconMore4"></i>
              </button>
            </li>
          </ul>
          <ul
            v-if="shopId === '30th' && !isEventProduct"
            class="payCoinAnnounce"
          >
            <li>- 본 상점은 청약철회가 불가능합니다.</li>
            <li>
              - 유효기간 경과 시 쿠폰 사용이 불가합니다.
            </li>
          </ul>
          <ul v-else-if="isEventProduct" class="payCoinAnnounce">
            <li>- 응모상품은 응모 후 취소가 불가능합니다.</li>
            <li>
              - 응모 방법 및 응모 후 당첨자 발표등은 상품설명 페이지에 안내된
              내용을 확인해주세요.
            </li>
          </ul>
          <ul v-else class="payCoinAnnounce">
            <li>- 구매 후 7일이내 구매확정 전 청약철회 가능합니다.</li>
            <li>
              - 유효기간 경과 시 쿠폰 사용이 불가하며 고객센터를 통해 문의
              부탁드립니다.
            </li>
          </ul>
        </div>
      </div>
      <div class="orderBtSec">
        <button type="button" class="button11" @click="handleClickOrder">
          <span>
            {{ isEventProduct ? '' : productPriceObj.price.addComma() }}
          </span>
          {{ isEventProduct ? '' : productPriceObj.currencyUnit }}
          {{ isEventProduct ? '응모하기' : '결제하기' }}
        </button>
      </div>
      <!-- <limit-guide
        v-if="flagLimitGuide && limitPricePage"
        :limitPricePage="limitPricePage"
        @load="handleLoadForIframe"
        @close="flagLimitGuide = false"
      ></limit-guide> -->
      <check-privacy-modal
        :show="checkPrivacyShow"
        class="modalCheckPrivacy"
        @closeModal="closeModal"
      ></check-privacy-modal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PaymentAPI from '@/api/payment'
import DeliveryAPI from '@/api/delivery'
import EventBus from '@/utils/eventBus'
import FormRadio from '@/views/base/FormRadio'
import FormCheckbox from '@/views/base/FormCheckbox'
import ProductItem from '@/views/base/ProductItem'
import LimitGuide from '@/views/order/LimitGuide'
import PostAddress from '@/views/order/PostAddress'
import CustomSelectBox from '@/views/base/FormDropdown'
import CheckPrivacyModal from '@/views/order/CheckPrivacyModal'
import {
  calProductsPriceObejct,
  beforeSendLog,
  isMobileOS,
  convertPaymentType,
  isIOSChrome
} from '@/utils'

export default {
  name: 'Order',
  components: {
    FormRadio,
    FormCheckbox,
    ProductItem,
    LimitGuide,
    PostAddress,
    CustomSelectBox,
    CheckPrivacyModal
  },
  props: {
    fromView: {
      type: Boolean,
      default: false
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      flagLimitGuide: false,
      agree: false,
      agree2: false,
      agrees: {},
      agreePayCoin: false,
      agreePayCoin2: false,
      paymentIndex: -1,
      paymentList: [],
      limitPricePage: '',
      rendingUrl: null,
      isMobileOS,
      postAddressLayer: false,
      postRequestsComment: [
        '직접입력',
        '직접 수령하겠습니다.',
        '문 앞에 놓아주세요.',
        '경비실에 맡겨주세요.',
        '배송 전 휴대폰으로 연락주세요.'
      ],
      postRequest: 0,
      postMessage: '',
      checkPrivacyShow: false,
      deliveryInformation: {
        receiverName: null,
        phoneNumber: null,
        zipCode: null,
        address: null,
        detailAddress: null,
        requestInfo: null
      }
    }
  },
  watch: {
    agreementList: {
      handler(n, o) {
        this.agree = false
        this.agree2 = false
        this.$set(this, 'agrees', {}) // 모두 초기화
        if (n) {
          n.forEach((el, idx) => {
            this.$set(this.agrees, idx, false)
          })
        }
      }
    },
    rendingUrl: {
      handler(n, o) {
        if (n) {
          this.setDelay(true)
        }
      }
    },
    flagLimitGuide: {
      handler(n, o) {
        if (n) {
          this.setDelay(true)
        }
      }
    },
    postRequest: {
      handler(n, o) {
        if (n) {
          this.postMessage = ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('main', ['paymentSystemType', 'shopId']),
    ...mapGetters('my', ['balance']),
    ...mapGetters('common', ['isLoading']),
    isAllAgree() {
      let result = true
      for (let key in this.agrees) {
        result = result && this.agrees[key]
        if (!result) break
      }

      if (this.isShippingProduct) {
        return this.agree && this.agree2 && result
      }

      return this.agree && result
    },
    selectedPayment() {
      return this.paymentList[this.paymentIndex]
    },
    isGameCoinPayment() {
      return this.paymentSystemType === 2
    },
    productPriceObj() {
      return calProductsPriceObejct(this.productList)
    },
    agreementList() {
      if (this.selectedPayment) {
        return this.selectedPayment.agreementList
      } else {
        return false
      }
    },
    isShippingProduct() {
      const shippingProduct = this.productList.find(product => {
        return product.type === 3 || product.type === 4
      })

      return shippingProduct !== undefined
    },
    isEventProduct() {
      const eventProduct = this.productList.find(product => {
        return product.type === 7
      })

      return eventProduct !== undefined
    }
  },
  beforeCreate() {
    if (isIOSChrome()) {
      const forceReload = sessionStorage.getItem('forceReload')
      if (forceReload !== 'true') {
        this.$store.commit('common/SET_LOADING_STATE', true)
        sessionStorage.setItem('forceReload', 'true')
        window.location.reload()
        return false
      } else {
        sessionStorage.removeItem('forceReload')
      }
    }
  },
  mounted() {
    if (!this.isGameCoinPayment) {
      PaymentAPI.getPaymentList(responseData => {
        if (responseData.data.paymentList.length) {
          this.paymentList = responseData.data.paymentList
          this.limitPricePage = responseData.data.limitPricePage
        } else {
          alert('결제 목록 불러오기 실패')
          this.$router.go(-1)
        }
      })

      DeliveryAPI.getDeliveryInfo(responseData => {
        this.deliveryInformation = responseData.data

        if (responseData.data.requestInfo) {
          const indexMessage = this.postRequestsComment.indexOf(
            responseData.data.requestInfo
          )

          if (indexMessage !== -1) {
            this.postRequest = indexMessage
          } else {
            this.postRequest = 0
            this.postMessage = responseData.data.requestInfo
          }
        }
      })

      window.addEventListener('message', this.handleMessage)

      EventBus.$on('changeUrl', () => {
        setTimeout(() => {
          if (
            this.selectedPayment &&
            this.selectedPayment.categoryName === 'PAYCO' &&
            this.rendingUrl
          ) {
            if (this.fromView) {
              this.$router.push({
                name: 'product',
                params: { productId: this.productList[0].productId.toString() }
              })
            } else {
              this.$router.push({ name: 'cart' })
            }
          } else {
            this.changeRendingUrl(null)
          }
        }, 100)
      })
    } else {
      this.getUserBalance()
    }
  },
  destroyed() {
    //destoryed
    if (!this.isGameCoinPayment) {
      window.removeEventListener('message', this.handleMessage)
    }
  },
  methods: {
    ...mapActions('my', ['getUserBalance']),
    ...mapActions('api', ['setDelay']),
    ...mapActions('modal', ['openModal']),
    // checkOrderDisabled() {
    //   if (this.isGameCoinPayment) {
    //     this.isOrderDisabled = !this.isAllAgree
    //   }
    //   this.isOrderDisabled = !this.isAllAgree || !this.selectedPayment
    // },
    changePostMessage(event) {
      if (event.target.value.length <= 50) {
        this.postMessage = event.target.value
      } else {
        this.$forceUpdate()
      }
    },
    changeRendingUrl(url) {
      this.rendingUrl = url
    },
    getPaymentName(categoryCode) {
      return convertPaymentType(categoryCode)
    },
    requestOrderCallback(responseData) {
      if (responseData.code === 0) {
        this.changeRendingUrl(responseData.data.dipayUrl)
      }
      beforeSendLog('Charge', {
        RequestSuccess: this.rendingUrl ? 0 : 1
      })
    },
    requestGameCoinOrderCallback(responseData) {
      if (responseData.code === 0) {
        const token = responseData.data.token
        PaymentAPI.getPaymentResult(token, resp => {
          if (resp.code === 0) {
            this.$router.replace({
              name: 'orderComplete',
              params: {
                result: resp.data,
                token,
                isShippingProduct: this.isShippingProduct,
                isEventProduct: this.isEventProduct,
                productType: this.isShippingProduct
                  ? this.productList[0].type
                  : ''
              }
            })
          } else {
            this.rendingUrl = null
          }
        })
      }
    },
    isSingleCharacter(text) {
      var strGa = 44032 // 가
      var strHih = 55203 // 힣

      var lastStrCode = text.charCodeAt(text.length - 1)

      if (lastStrCode < strGa || lastStrCode > strHih) {
        return false //한글이 아닐 경우 false 반환
      }
      return (lastStrCode - strGa) % 28 == 0
    },
    processPayment() {
      if (this.fromView) {
        this.deliveryInformation.requestInfo =
          this.postRequest === 0
            ? this.postMessage
            : this.postRequestsComment[this.postRequest]
        PaymentAPI.payProduct(
          {
            product: this.productList[0],
            paymentType: !this.isGameCoinPayment
              ? this.selectedPayment.categoryCode
              : 101,
            deliveryInfo: this.isShippingProduct
              ? this.deliveryInformation
              : null
          },
          !this.isGameCoinPayment
            ? this.requestOrderCallback
            : this.requestGameCoinOrderCallback
        )
      } else {
        const { price, displayPrice } = this.productPriceObj
        PaymentAPI.payProductsInCart(
          {
            price,
            displayPrice,
            paymentType: this.selectedPayment.categoryCode,
            productList: this.productList
          },
          this.requestOrderCallback
        )
      }
    },
    handleClickOrder() {
      let message = ''
      switch (this.paymentSystemType) {
        case 1:
          if (typeof this.selectedPayment === 'undefined') {
            message = '결제 수단을 선택해주세요.'
          } else if (this.agree === false) {
            message = '구매조건 확인 동의를 체크해주세요'
          } else if (this.isShippingProduct && this.agree2 === false) {
            message = '개인정보 수집 및 이용 동의를 체크해주세요'
          } else if (this.agrees && this.isAllAgree === false) {
            message = '결제를 위한 결제대행사 결제정보 위탁동의를 체크해주세요'
          }
          break
        case 2:
          if (this.agreePayCoin === false) {
            message = '구매조건 확인 동의를 체크해주세요'
          } else if (this.isShippingProduct && this.agreePayCoin2 === false) {
            message = '개인정보 수집 및 이용 동의를 체크해주세요'
          }
          break
      }

      if (message.length > 0) {
        return this.openModal({
          type: 'alert',
          message
        })
      }

      const confimrMessage = this.isEventProduct
        ? '응모하시겠습니까?'
        : this.isGameCoinPayment
        ? `보유하신 ${this.balance.currencyName}${
            this.isSingleCharacter(this.balance.currencyName) ? '로' : '으로'
          } <br> 결제를 진행하시겠습니까?`
        : '결제를 진행하시겠습니까?'

      this.openModal({
        type: 'alert',
        message: confimrMessage,
        canCancel: true,
        confirmText: '확인',
        callback: () => {
          this.processPayment()
        }
      })
    },
    handleClickDetail(agreement) {
      if (agreement) {
        this.openModal({
          type: 'alert',
          header: agreement.title,
          message: `<div class=modalBodyBg><p>${agreement.content}</p></div>`
        })
        /* '<div class=modalBodyBg><p>(주)넥슨코리아는 회원님께서 주문하신 상품의 결제를 위해 아래와 같이 업무를 위탁하여 운영 하고 있습니다.</p><dl><dt>위탁대상</dt><dd>다날</dd></dl><dl><dt>위탁목적</dt><dd>휴대폰을 이용한 주문상품의 결제 및 요금 정산, 부정결제 방지</dd></dl></div>' */
      }
    },
    handleCheck(type, key) {
      if (type === 'check') {
        if (typeof this[key] !== 'undefined') {
          // agree
          this[key] = !this[key]
        } else if (typeof key === 'number') {
          // agrees
          this.agrees[key] = !this.agrees[key]
        } else if (key === 'all') {
          const prev = this.isAllAgree
          this.agree = !prev
          this.agree2 = !prev
          for (let key in this.agrees) {
            this.agrees[key] = !prev
          }
        }
      } else if (type === 'radio') {
        this.paymentIndex = key
      }
    },
    handleMessage(e) {
      const { token } = e.data
      if (token) {
        if (this.rendingUrl) {
          PaymentAPI.getPaymentResult(token, responseData => {
            if (responseData.code === 0) {
              if (this.fromView === false) {
                // 장바구니 결제 시 장바구니 삭제
                this.$store.commit(
                  'cart/REMOVE_PRODUCT_OF_CART',
                  this.productList.map(el => el.productId)
                )
              }

              this.$router.replace({
                name: 'orderComplete',
                params: {
                  result: responseData.data,
                  token,
                  isShippingProduct: this.isShippingProduct,
                  isEventProduct: this.isEventProduct,
                  productType: this.isShippingProduct
                    ? this.productList[0].type
                    : ''
                }
              })
            } else {
              this.rendingUrl = null
            }
          })
        }
      }
    },
    handleLoadForIframe(e) {
      this.setDelay(false)
    },
    showLayer(state) {
      if (state) {
        beforeSendLog('Popup')
      }
      this.postAddressLayer = state
    },
    onClickChangeAddress() {
      beforeSendLog('AddressChange')
      this.showLayer(true)
    },
    closeModal() {
      this.checkPrivacyShow = false
    },
    changeDeliveryInformation(info) {
      this.deliveryInformation = info
    }
  }
}
</script>

<style lang="scss">
.order {
  iframe {
    display: block;
    background: #fff;
    border: none;
    &.processing {
      height: 70vh;
      width: 100%;
      margin-bottom: -1px;
    }
  }
  h2 {
    height: 42px;
    padding: 15px 16px 0;
    margin: 0;
    font-size: 15px;
    border-bottom: 1px solid #d6d6db;
    box-sizing: border-box;
  }
  .orderPrice,
  .orderPayCoin,
  .orderPayMethod,
  .orderPayInfo {
    margin-top: 10px;
    background-color: #fff;
    border-bottom: 1px solid #efefef;
  }
  .orderPrice,
  .orderComplete {
    div {
      padding: 14px 16px 0;
    }
    dl {
      display: table;
      width: 100%;
      height: 26px;
    }
    dt,
    dd {
      display: table-cell;
    }
    dt {
      font-size: 13px;
      color: #636376;
    }
    dd {
      font-size: 15px;
      text-align: right;
    }
    dl:last-child {
      margin-top: 3px;
      font-weight: bold;
      border-top: 1px solid #636376;
      dt,
      dd {
        padding-top: 14px;
        height: 41px;
      }
      dt {
        font-size: 14px;
        color: #151721;
      }
      dd {
        font-size: 16px;
        color: #6134f1;
      }
    }
  }
  .orderPayMethod {
    position: relative;
    .btLimitGuide {
      position: absolute;
      top: 16px;
      right: 15px;
      height: 14px;
      color: #8b8b91;
      font-size: 11px;
      border-bottom: 1px solid #8b8b91;
      .icon {
        margin: 0 2px 2px 0;
      }
    }
    ul {
      padding: 10px 6px 0 16px;
    }
    li {
      display: inline-block;
      width: 50%;
      padding: 0 10px 10px 0;
      div {
        width: 100%;
        height: 45px;
      }
      label {
        width: 100%;
        height: 45px;
        line-height: 38px;
        font-size: 16px;
        color: #8b8b91;
        text-align: center;
        border: 2px solid #8b8b91;
        &::before {
          display: none;
        }
      }
      input[check='true'] + label {
        color: #6134f1;
        font-weight: bold;
        border-color: #6134f1;
      }
    }
    dl {
      font-size: 12px;
      padding: 16px 16px 14px;
    }
    dt {
      display: inline-block;
      width: 83px;
      color: #151721;
      vertical-align: top;
      .icon {
        margin: -1px 2px 0 0;
      }
    }
    dd {
      display: inline-block;
      width: calc(100% - 83px);
      color: #636376;
    }
    // .payiOS .paySelect1 {
    //   position: relative;
    //   &::after {
    //     content: "카카오페이 준비중";
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
    //     display: block;
    //     line-height: 46px;
    //     font-size: 16px;
    //     color: #8b8b91;
    //     text-align: center;
    //     background-color: rgba(221,221,221,0.7);
    //   }
    //   label span {
    //     opacity: 0;
    //   }
    // }
    // .payAndroidOS .paySelect1 {
    //   position: relative;
    //   &::after {
    //     content: "카카오페이 준비중";
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
    //     display: block;
    //     line-height: 46px;
    //     font-size: 16px;
    //     color: #8b8b91;
    //     text-align: center;
    //     background-color: rgba(221,221,221,0.7);
    //   }
    //   label span {
    //     opacity: 0;
    //   }
    // }
    // .payAndroidOS .paySelect3 {
    //   position: relative;
    //   &::after {
    //     content: "PAYCO 준비중";
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
    //     display: block;
    //     line-height: 46px;
    //     font-size: 16px;
    //     color: #8b8b91;
    //     text-align: center;
    //     background-color: rgba(221,221,221,0.7);
    //   }
    //   label span {
    //     opacity: 0;
    //   }
    // }
  }
  .orderPayCoin {
    h2 {
      border-bottom: none;
    }
    > div {
      padding: 14px 16px 0;
    }
    dl {
      display: table;
      width: 100%;
      margin-bottom: 16px;
    }
    dt,
    dd {
      display: table-cell;
      color: #151721;
    }
    dt {
      font-size: 13px;
    }
    dd {
      font-size: 16px;
      text-align: right;
    }
    .payCoinAgree {
      border-top: 1px solid #d6d6db;
      padding-top: 13px;
      color: #636376;
      li {
        position: relative;
        padding-top: 5px;
      }
      .btShare {
        position: absolute;
        top: 10px;
        right: 3px;
        color: #8b8b91;
        font-size: 11px;
        .icon {
          margin: -2px 0 0 4px;
        }
      }
      label {
        font-size: 12px;
      }
    }
    .payCoinAnnounce {
      padding: 14px 0 14px;
      font-size: 10px;
      line-height: 17px;
      color: #8b8b91;
      background-color: #fff;
      border-bottom: 1px solid #efefef;
    }
  }
  .orderAgree {
    margin-top: 10px;
    background-color: #fff;
    h2 {
      height: 41px;
      padding: 10px 11px 0;
      font-weight: normal;
      label {
        font-size: 13px;
      }
    }
    ul {
      padding: 5px 11px 10px;
      label {
        font-size: 12px;
        color: #636376;
      }
    }
    li {
      position: relative;
      padding-top: 5px;
    }
    .btShare {
      position: absolute;
      top: 10px;
      right: 3px;
      color: #8b8b91;
      font-size: 11px;
      .icon {
        margin: -2px 0 0 4px;
      }
    }
  }
  .orderAnnounce {
    padding: 5px 12px 14px;
    font-size: 10px;
    line-height: 12px;
    color: #8b8b91;
    background-color: #fff;
    border-bottom: 1px solid #efefef;
    li {
      padding-bottom: 3px;
    }
  }
  .orderBtSec {
    width: 100%;
    padding: 10px 10px 0;
    // height: 64px; safeArea
    button {
      border-radius: 4px;
      span {
        font-weight: bold;
      }
    }
    .button51,
    .button52,
    .button53 {
      width: calc(50% - 3px);
      margin-right: 6px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
